$(".btn").each(function (index) {
  $(this).addClass("group");
});
